/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPieLineNested: {
  name: 'pie-line-nested';
  data: string;
} = {
  name: 'pie-line-nested',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 0 1 8-8 1 1 0 1 0 0-2C6.477 2 2 6.477 2 12s4.477 10 10 10a10 10 0 0 0 8.96-5.555 1 1 0 1 0-1.791-.89A8 8 0 0 1 4 12Zm12.445-8.96a1 1 0 1 0-.89 1.791 8.017 8.017 0 0 1 4.247 5.39 1 1 0 1 0 1.95-.442 10.017 10.017 0 0 0-5.307-6.739ZM8.799 9.6a4 4 0 0 1 6.402 4.799 1 1 0 0 0 1.599 1.202A6 6 0 1 0 7.2 8.4a1 1 0 0 0 1.6 1.2Zm-.719 3.201a1 1 0 1 0-1.96.398 6.006 6.006 0 0 0 4.681 4.681 1 1 0 1 0 .398-1.96 4.006 4.006 0 0 1-3.119-3.119Z" fill="currentColor"/></svg>`,
};
